import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import DeecaLogo from '../images/deeca-logo.png'
import colours from '../lib/colours'
import { MobileDeviceWidth, SystemName, TabletDeviceWidth } from '../lib/constants'
import IEventedComponent from './IEventedComponent'

const StyledHeader = styled.header`
  background: ${colours.darkPurple};
  color: ${colours.white};
  height: 70px;
  display: flex;
`

const StyledImageContainer = styled.div`
  width: 180px;
`

const StyledLinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: calc(100% - 360px);
  @media (max-width: ${MobileDeviceWidth}px) {
    width: calc(100% - 180px);
  }
`

const StyledImage = styled.img`
  height: 50px;
  margin-top: 10px;
  margin-left: 25px;
  margin-bottom: 10px;
  margin-right: 10px;
  @media (max-width: ${MobileDeviceWidth}px) {
    margin-left: 10px;
  }
`
const StyledH1 = styled.h1`
  font-size: 26px;
  color: ${colours.white};
  margin: 0;
  @media (max-width: ${TabletDeviceWidth}px) {
    font-size: 22px;
  }
  @media (max-width: ${MobileDeviceWidth}px) {
    font-size: 18px;
  }
`

interface IProps {}

interface IState {}

const Header = class extends IEventedComponent<IProps, IState> {
  render() {
    return (
      <StyledHeader>
        <StyledImageContainer>
          <a href="https://delwp.vic.gov.au" target="_blank" rel="noopener noreferrer">
            <StyledImage src={DeecaLogo} alt="Department of Energy, Environment and Climate Action Logo" />
          </a>
        </StyledImageContainer>
        <StyledLinkContainer>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <StyledH1>{SystemName}</StyledH1>
          </Link>
        </StyledLinkContainer>
      </StyledHeader>
    )
  }
}

export default Header
